
import axios from "axios";
import { getConfig } from "../../../ApiHelpers/ApiDefaultConfig";
import { UserSessionsFilters, UserSessionsResponse } from "./models";


const getUserSessions = async ({ userId, startDate, endDate }: UserSessionsFilters): Promise<UserSessionsResponse> => {
    let config = getConfig();
    try {
        const response = await axios.get(`/admin/user-sessions?userId=${userId}&startDate=${startDate}&endDate=${endDate}`, config);
        return response.data as UserSessionsResponse;
    } catch (error) {
        return error as any
    }
}


export { getUserSessions };